import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

export const AccountTabs = (mainTabLabel: any) => {
    const router = useNavigate();

    const assignedMenu: any = localStorage.getItem('assigned_menu') ? localStorage.getItem('assigned_menu') : '';

    const HRitems: MenuItem[] = [
        {
            label: 'Bank Entry',
            command: () => {
                router('/app/account/bank-entry');
            }
        },
        {
            label: 'Cash Entry',
            command: () => {
                router('/app/account/cash-entry');
            }
        },
        {
            label: 'JV Entry',
            command: () => {
                router('/app/account/jv-entry-list');
            }
        },
        {
            label: 'Account Master',
            command: () => {
                router('/app/account-master');
            }
        },
        {
            label: 'Account Group',
            command: () => {
                router('/app/account-group');
            }
        }
    ];

    const [activeIndex, setActiveIndex] = useState<number>(0);

    // Convert string to Set
    const assignedMenuSet = new Set(assignedMenu.split(',').map((item: string) => item.trim()));

    // Filter HRitems by checking if label exists in assignedMenuSet
    const filteredHRitems = HRitems.filter((item) => item.label && assignedMenuSet.has(item.label));

    useEffect(() => {
        if (filteredHRitems.length > 0 && mainTabLabel) {
            const foundIndex = filteredHRitems.findIndex((item) => item.label == mainTabLabel.mainTabLabel);
            setActiveIndex(foundIndex >= 0 ? foundIndex : 0);
        }
    }, [filteredHRitems]);

    return (
        <>
            <TabMenu model={filteredHRitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab" />
        </>
    );
};
